import { useEffect, useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const scrollPositions = new Map<string, number>();

/**
 * PUSH/REPLACE(새 화면 이동): 맨 위로 스크롤
 * POP(뒤로가기): 이전에 저장한 스크롤 위치 복원
 */
const ScrollRestoration = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const locationKeyRef = useRef(location.key);

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    locationKeyRef.current = location.key;

    const applyScroll = () => {
      if (navigationType === 'POP') {
        const savedY = scrollPositions.get(location.key);
        window.scrollTo(0, savedY ?? 0);
      } else {
        window.scrollTo(0, 0);
      }
    };

    applyScroll();
    const frameId = requestAnimationFrame(applyScroll);
    return () => cancelAnimationFrame(frameId);
  }, [location.key, location.pathname, navigationType]);

  useLayoutEffect(() => {
    const key = location.key;
    return () => {
      scrollPositions.set(key, window.scrollY);
    };
  }, [location.key]);

  return null;
};

export default ScrollRestoration;
